module.exports = __webpack_public_path__ + "img/dildo-rabbit.2f05191f.svg";